import { AfterContentChecked, Component, OnInit, Input, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { TableData, TableOptions, RequestResult } from '../../../shared/shared.model';
import { Capa, CapaStatus } from '../../audit.model';
import { DatePipe } from '@angular/common';
import { DISPLAY_DATE_FORMAT } from '../../../app.constants';
import { Observable } from 'rxjs';
import { CapaService } from '../../capa.service';
import { Router } from '@angular/router';

@Component({
  selector: 'iaud-capa-list',
  templateUrl: './capa-list.component.html',
  styleUrls: ['./capa-list.component.scss']
})
export class CapaListComponent implements OnInit, AfterContentChecked {
  @ViewChild('evidenceRights') evidenceRightsTemplate: TemplateRef<any>;
  @ViewChild('statusCellTemplate') statusCellTemplate: TemplateRef<any>;
  @ViewChild('picsDetailTemplate') picsDetailTemplate: TemplateRef<any>;

  @Input()
  findingId: number = 0;
  @Input()
  sidId: number = 0;
  @Input()
  auditId: number = 0;
  @Input()
  canAdd: boolean = true;
  @Input()
  reloadCapa?: EventEmitter<boolean>;
  toEvidence: boolean = false;
  @Input() set evidence(value: boolean) {
    this.toEvidence = value;
    //this.capaTableOptions.hrefBase = `/audit/${this.auditId}/finding/${this.findingId}/capa${this.toEvidence ? 'evidence' : ''}`;
  }
  get evidence(): boolean {
    return this.toEvidence;
  }

  capaTableData: TableData<Capa>;
  forceReloadEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  hasInitialCapas: boolean = null;

  capaTableOptions: TableOptions = {
    actionButtons: true,
    hideDeleteButton: !this.canAdd,
    columns: [
      {
        title: 'CAPA/EC ID',
        fieldName: 'capaId',
      },
      {
        title: 'CAPA/EC Title',
        fieldName: 'capaTitle',
      },
      {
        title: 'CAPA/EC Type',
        fieldName: 'capaEcType',
      },
      {
        title: 'Status',
        fieldName: 'status',
      },
      {
        title: 'Evidence Submission Due Date',
        fieldName: 'evidenceDueDate',
        pipe: new DatePipe('en-US'),
        pipeParams: DISPLAY_DATE_FORMAT,
      },
    ],
    additionalInfo: [
      {
        title: 'Evidence Submission Rights',
        fieldName: 'allMustSubmit',
      },
      {
        title: 'CAPA/EC PICs',
        fieldName: 'capaPics',
      },
      {
        title: 'CAPA/EC Description',
        fieldName: 'description',
      },
    ],
  };

  constructor(
    private capaService: CapaService,
    private router: Router
  ) { }

  ngOnInit(): void {
    //this.capaTableOptions.hrefBase = `/audit/${this.auditId}/finding/${this.findingId}/capa${this.toEvidence ? 'evidence' : ''}`;
    this.capaTableOptions.hideDeleteButton = !this.canAdd;
    this.refreshData();
    if (this.reloadCapa) {
      this.reloadCapa.subscribe(() => {
        this.forceReloadEvent.emit(true);
      });
    }
  }
  refreshData(): void {
    this.reloadCapaList()
      .subscribe(table => {
        this.capaTableData = table;
        if (this.hasInitialCapas == null) {
          this.hasInitialCapas = table.items.length > 0;
        }
      });
  }
  ngAfterContentChecked(): void {
    this.capaTableOptions.columns[3].customTemplate = this.statusCellTemplate;
    this.capaTableOptions.additionalInfo[0].customTemplate = this.evidenceRightsTemplate;
    this.capaTableOptions.additionalInfo[1].customTemplate = this.picsDetailTemplate;
  }
  reloadCapaList(page: number = 0, pageSize: number = 10): Observable<TableData<Capa>> {
    if (this.findingId) {
      return this.capaService.getCapaList(this.findingId, page, pageSize);
    } else {
      return this.capaService.getCapaListBySid(this.sidId, page, pageSize);
    }
  }
  deleteData(id: number): Observable<RequestResult> {
    return this.capaService.deleteCapa(id);
  }
  capaDetailClick(_id: number, data: Capa): void {
    if (this.findingId) {
      if (data.status === CapaStatus.PENDING_APPROVAL) {
        this.router.navigateByUrl(`/audit/${this.auditId}/finding/${this.findingId}/capa/${data.id}/approval`);
      } else if (data.status === CapaStatus.APPROVED) {
        this.router.navigateByUrl(`/audit/${this.auditId}/finding/${this.findingId}/capaevidence/${data.id}`);
      }else{
        this.router.navigateByUrl(`/audit/${this.auditId}/finding/${this.findingId}/capa${this.toEvidence ? 'evidence' : ''}/${data.id}`);
      }
    } else if (this.sidId) {
      if (data.status === CapaStatus.PENDING_FOR_EVIDENCE || data.status === CapaStatus.RETURNED || data.status === CapaStatus.APPROVED) {
        this.router.navigateByUrl(`/sid/${this.sidId}/capaevidence/${data.id}`);
      } else if (data.status === CapaStatus.PENDING_APPROVAL) {
        this.router.navigateByUrl(`/sid/${this.sidId}/capa/${data.id}/approval`);
      } else{
        this.router.navigateByUrl(`/sid/${this.sidId}/capa${this.toEvidence ? 'evidence' : ''}/${data.id}`);
      }
      //this.router.navigateByUrl(`/sid/${this.sidId}/capa/${data.id}`);
    }
  }
}
